import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=4c64eb4b&scoped=true"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"
import style0 from "./AppProfile.vue?vue&type=style&index=0&id=4c64eb4b&prod&lang=scss"
import style1 from "./AppProfile.vue?vue&type=style&index=1&id=4c64eb4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64eb4b",
  null
  
)

export default component.exports